import _ from 'lodash';
import { connect } from 'react-redux';
import { add, update, get } from '../../modules/logistics/carrier';
import { bindActionCreators } from 'redux';

const mapStateToProps = (state, ownProps) => {

	const carrierId = (ownProps.carrierId)
		? ownProps.carrierId
		: _.get(ownProps, ['match', 'params', 'carrierId']);
	const carrier = _.get(state.maps, ['carrier', carrierId]);

	return {
		carrier
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	getCarrier : get,
	addCarrier : add,
	updateCarrier : update,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
